import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

import * as at from "../actions/types";

const initialState = {
  loading: false,
  data: {},
};

const resources = (state = initialState, action) => {
  switch (action.type) {
    case at.CLEAR_RESOURCES:
      return { ...state, data: {} };
    case errorAction(types.GET_ALL_MY_RESOURCES):
      return { ...state, loading: false };
    case successAction(types.GET_ALL_MY_RESOURCES):
      return { ...state, data: action.payload.data, loading: false };
    case requestAction(types.GET_ALL_MY_RESOURCES):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default resources;
